<template>
  <div class="c--referral_contents new-container mx-auto">
    <div class="referral-contents d-grid grid-cols-lg-12 gap-20 gap-sm-30 gap-lg-40">
      <div
        v-for="(content, index) in contents"
        :key="`referral-content-item-${index}`"
        class="referral-content-item col-span-lg-10 col-start-lg-2 d-grid grid-cols-1 grid-cols-lg-10 gap-30 tw-text-center lg:tw-custom-text-align-inherit"
      >
        <div
          :class="[
            'referral-content-item-text col-span-lg-4',
            {
              'col-start-lg-7 reverse-layout': content.reverse,
            },
          ]"
        >
          <h2>{{ content.title }}</h2>
          <p v-html="content.content" class="tw-whitespace-pre-line" />
          <nuxt-link
            v-if="content.key === 'how-does-referral-program-work'"
            :to="localePath('/referral/referral-terms-and-conditions')"
            class="referral-page-terms-conditions-link"
          >
            {{ $t('scenes.referral.terms.and.conditions.title') }}
          </nuxt-link>
        </div>
        <div
          :class="[
            'referral-content-item-image col-span-lg-5',
            {
              'col-start-lg-6': !content.reverse,
              'col-start-lg-1 reverse-layout': content.reverse,
            },
          ]"
        >
          <nuxt-img :src="content.img" alt="" width="445" height="455" loading="lazy" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'referral-contents',

    props: ['contents'],
  }
</script>

<style lang="scss" scoped>
  .referral-contents {
    .referral-content-item {
      align-items: center;

      &-text {
        &.reverse-layout {
          order: 2;
        }

        h2 {
          color: #4a4a4a;
          font-size: 27px;
          font-weight: 600;
          letter-spacing: -0.5px;
          line-height: 32px;
          margin-bottom: 0;
        }
        p {
          color: #8a8a8a;
          font-size: 15px;
          letter-spacing: 0;
          line-height: 21px;
          margin-top: 10px;
          margin-bottom: 0;
        }
        ::v-deep p {
          margin-bottom: 0;
        }
        .referral-page-terms-conditions-link {
          color: #4a4a4a;
          font-size: 15px;
          letter-spacing: 0;
          line-height: 21px;
          text-decoration: underline;
        }
      }
      &-image {
        &.reverse-layout {
          order: 1;
        }

        img {
          max-width: 100%;
          height: auto;
        }
      }
    }
  }
  @media only screen and (max-width: 991px) {
    .referral-contents {
      .referral-content-item {
        &-image {
          order: 1;
        }
        &-text {
          order: 2;
        }
      }
    }
  }
  @media only screen and (max-width: 567px) {
    .referral-contents {
      .referral-content-item {
        &-text {
          h2 {
            color: #4a4a4a;
            font-size: 19px;
            font-weight: 600;
            letter-spacing: -0.2px;
            line-height: 22px;
          }
        }
      }
    }
  }
</style>
